import { Typography } from "@material-ui/core";
import React from "react";
import { Link, useLocation } from "react-router-dom";

const NavLinks = (props) => {
  const { routes } = props;
  const location = useLocation();

  const styles = {
    container: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    link: {
      cursor: "pointer",
      textDecoration: "none",
      textEmphasis: "none",
      textAlign: "center",
    },
  };
  return (
    <div style={{ ...styles.container, ...props.style }}>
      {routes.map((item, key) => {
        return (
          <Link
            to={item.path}
            style={{
              ...styles.link,
              marginRight: "3%",
            }}
            key={key}
          >
            <Typography
              variant="h6"
              style={{ color: location.pathname === item.path ? "#D3B925" : props.linkColor ? props.linkColor : "#333333" }}
            >
              {item.label}
            </Typography>
          </Link>
        );
      })}
    </div>
  );
};

export default NavLinks;
